import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';

function LoginForm({ busyAction, form, onChange, onForgotPassword, onModeChange, onSubmit }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        label="Email"
        onChange={(event) => onChange({ ...form, email: event.target.value })}
        type="email"
        value={form.email}
      />
      <TextField
        fullWidth
        label="Password"
        onChange={(event) => onChange({ ...form, password: event.target.value })}
        type={showPassword ? 'text' : 'password'}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  edge="end"
                  onClick={() => setShowPassword((current) => !current)}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        value={form.password}
      />

      <Stack
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        spacing={1}
      >
        <FormControlLabel control={<Checkbox defaultChecked size="small" />} label="Remember me" />
        <Link component="button" onClick={onForgotPassword} type="button" underline="hover">
          Forgot your password?
        </Link>
      </Stack>

      <Button
        disabled={busyAction === 'login'}
        fullWidth
        onClick={onSubmit}
        size="large"
        variant="contained"
      >
        {busyAction === 'login' ? 'Signing in...' : 'Sign in'}
      </Button>

      <Divider>or</Divider>

      <Typography color="text.secondary" textAlign="center" variant="body2">
        Don&apos;t have an account?{' '}
        <Link component="button" onClick={() => onModeChange('signup')} type="button" underline="hover">
          Sign up
        </Link>
      </Typography>
    </Stack>
  );
}

export default LoginForm;
